import { Inject, Injectable, Optional } from '@angular/core';
import { DashboardWidgetRegistration } from '../models/dashboard-widget.types';
import { DASHBOARD_WIDGETS } from './dashboard-widget.token';

@Injectable({ providedIn: 'root' })
export class DashboardWidgetRegistryService {
  private readonly registrations: DashboardWidgetRegistration[] = [];

  constructor(
    @Optional() @Inject(DASHBOARD_WIDGETS)
    registrationGroups: DashboardWidgetRegistration[][] | null
  ) {
    for (const group of registrationGroups ?? []) {
      for (const registration of group) {
        this.register(registration);
      }
    }
  }

  register(registration: DashboardWidgetRegistration): void {
    if (this.get(registration.type)) {
      throw new Error(`Widget type "${registration.type}" is already registered.`);
    }
    this.registrations.push(registration);
  }

  get(type: string): DashboardWidgetRegistration | undefined {
    return this.registrations.find(item => item.type === type);
  }

  getAll(): DashboardWidgetRegistration[] {
    return [...this.registrations];
  }
}
